import throttle from 'lodash/throttle';
import { useState, useEffect } from 'react';

/**
 * useResize hook will invoke onResize callback after throttleWaitMs everytime the window is resized
 * @param {function(): *} onResize
 * @param {number} throttleWaitMs
 */
export default function useResize(onResize, throttleWaitMs = 200) {
    const onResizeThrottled = throttle(() => onResize(), throttleWaitMs);
    const [res, setRes] = useState(onResize());

    useEffect(() => {
        const handleResize = () => setRes(onResizeThrottled());

        window.addEventListener('resize', handleResize, true);
        return () => {
            window.removeEventListener('resize', handleResize, true);
        };
    }, [onResizeThrottled]);

    return res;
}
